module.exports = __webpack_public_path__ + "01_very_short_black.a75e1efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_very_short_black.png
// module id = J0yL
// module chunks = 0